import React from 'react'
import ContactSection from '../components/ContactSection'
import InquiryForm from '../components/InquiryForm'
import MapSection from '../components/MapSection'

function ContactUs() {
    return (
        <>
            <ContactSection />

            <InquiryForm /> 

            <MapSection />
        </>
    )
}

export default ContactUs